var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70999 1.20999C6.61747 1.11728 6.50758 1.04373 6.38661 0.993553C6.26564 0.943372 6.13595 0.917542 6.00499 0.917542C5.87402 0.917542 5.74433 0.943372 5.62336 0.993553C5.50239 1.04373 5.3925 1.11728 5.29999 1.20999L0.709986 5.79999C0.617282 5.8925 0.543735 6.00239 0.493553 6.12336C0.443372 6.24433 0.417542 6.37402 0.417542 6.50499C0.417542 6.63595 0.443372 6.76564 0.493553 6.88661C0.543735 7.00758 0.617282 7.11747 0.709986 7.20999L5.29999 11.8C5.39257 11.8926 5.50248 11.966 5.62344 12.0161C5.74441 12.0662 5.87406 12.092 6.00499 12.092C6.13592 12.092 6.26556 12.0662 6.38653 12.0161C6.50749 11.966 6.6174 11.8926 6.70999 11.8C6.80257 11.7074 6.87601 11.5975 6.92611 11.4765C6.97622 11.3556 7.00201 11.2259 7.00201 11.095C7.00201 10.9641 6.97622 10.8344 6.92611 10.7134C6.87601 10.5925 6.80257 10.4826 6.70999 10.39L2.82999 6.49999L6.70999 2.61999C7.09999 2.22999 7.08999 1.58999 6.70999 1.20999Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.bcd35e2ebb05e6e0ef314454ab2c6c28.svg";
export { ForwardRef as ReactComponent };